// The masterclass's home, /masterclass (Masterclass.dc.html), plugged into the product routes by its
// file name (src/product/screens.js): the product frame draws the header, the menu (Home only) and
// the footer around it. Only the home: any other /masterclass/... path stays the shared page or
// "There's nothing here", so this isn't Masterclass.jsx, which would take every page.
import MasterclassPage from '../../products/masterclass/MasterclassPage.jsx'

export default function MasterclassHome({ product }) {
  return <MasterclassPage product={product} />
}
